export type CalendarEventData = {
  contentId: string;
  fullUrl: string;
};
export class CalendarEvent {
  private data: CalendarEventData;
  constructor(data: CalendarEventData) {
    this.data = data;
  }

  deepLinkUrl(): string | Error {
    try {
      const url = new URL(this.data.fullUrl);
      const searchParams = new URLSearchParams(url.search);
      searchParams.set('contentId', this.data.contentId);
      const deepLinkUrl = `${url.origin}${url.pathname}?${searchParams.toString()}`;

      return deepLinkUrl;
    } catch (e) {
      if (typeof e === 'string') {
        return new Error(e);
      }
      if (e instanceof Error) {
        return e;
      }
      return new Error('Unexpected type of error while creating a deep link');
    }
  }
}
